import { Component, OnInit } from "@angular/core";
import { StripeSource } from "stripe-angular";
@Component({
  selector: "app-stripe",
  templateUrl: "./stripe.component.html",
  styleUrls: ["./stripe.component.css"],
})
export class StripeComponent implements OnInit {
  constructor() {}
  invalidError: any;
  cardReady = false;
  extraData = {
    name: "ajay",
  };
  ngOnInit(): void {}
  onStripeInvalid(error: Error) {}

  setStripeToken(token: stripe.Token) {}

  setStripeSource(source: StripeSource) {}

  onStripeError(error: Error) {}
}
